import React from "react";
import { useTheme } from "@mui/material/styles";
import { Typography, Box } from "@mui/material";

import ModalContainer from "components/ModalContainer";
import { SolidWarnButton } from "components/buttons/SolidWarnButton";
import { OutlineButton } from "components/buttons/OutlineButton";

const ConfirmDeleteModal = ({
  removeModal,
  onOpenRemoveModal,
  label,
  removeCallback
}) => {
  const theme = useTheme();

  return (
    <>
      <ModalContainer display={removeModal} modalWidth="500px">
        <Box sx={{ textAlign: "center" }}>
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontFamily: theme.typography.fontFamily,
              fontWeight: theme.typography.customFontWeight[3],
              fontSize: theme.typography.customFontSize[5],
            }}
          >
            Remove {label}
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Typography
              sx={{
                color: theme.palette.primary.black,
                fontSize: theme.typography.customFontSize[3],
                fontFamily: theme.typography.fontFamily,
                fontWeight: theme.typography.customFontWeight[0],
                whiteSpace: "pre-wrap",
              }}
            >
              Are you sure you want to remove "{label}"?
            </Typography>
          </Box>

          <Box
            sx={{
              paddingTop: "20px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <OutlineButton
              onClick={() => onOpenRemoveModal(false)}
              sx={{ marginRight: "20px" }}
              width="100px"
              height="32px"
            >
              Cancel
            </OutlineButton>
            <SolidWarnButton onClick={removeCallback} width="100px" height="32px">
              Remove
            </SolidWarnButton>
          </Box>
        </Box>
      </ModalContainer>
    </>
  )
}

export default ConfirmDeleteModal;